const constants = {
  FETCH_FAILURE: 'Page/FETCH_FAILURE',
  FETCH_REQUEST: 'Page/FETCH_REQUEST',
  FETCH_SUCCESS: 'Page/FETCH_SUCCESS',
  SET_MODULE: 'Page/SET_MODULE',
  SWITCH_MODAL_VIEW: 'Page/SWITCH_MODAL_VIEW',
}

export default constants
